import logo from "@/assets/logo.png";
import logoLight from "@/assets/logo-light.png";
import mark from "@/assets/mark.png";
import markLight from "@/assets/mark-light.png";

import { cn } from "@/utils/utils";

/** The S&R lockup. `tone` picks the artwork that suits the surface behind it. */
export function Logo({
  tone = "ink",
  className,
}: {
  tone?: "ink" | "light";
  className?: string;
}) {
  return (
    <img
      src={tone === "light" ? logoLight : logo}
      alt="S&R Membership Shopping"
      width={560}
      height={261}
      className={cn("h-auto w-36", className)}
    />
  );
}

/** The S glyph alone, for tight spaces like the sidebar rail. */
export function Mark({
  tone = "ink",
  className,
}: {
  tone?: "ink" | "light";
  className?: string;
}) {
  return (
    <img
      src={tone === "light" ? markLight : mark}
      alt=""
      aria-hidden
      width={96}
      height={110}
      className={cn("h-6 w-auto", className)}
    />
  );
}
